module.exports = __webpack_public_path__ + "img/ibon.0cfe579.png";